<template>
  <div class="product-ct">
    <h3 class="app-title">
      <span>
        {{ app.name }}
        <span v-if="app.isNew" class="badge" title="New product">New</span>
        <span v-if="app.isUpdated" class="badge updated" title="Product updated">Updated</span>
      </span>
      <a
        href="javascript:;"
        @click="markFav(app)"
        class="fav-icon"
        title="Add to favorites."
        v-bind:class="{ 'selected-fav': app.isFavorite }"
      >
        <i class="material-icons">grade</i>
      </a>
    </h3>
    <div class="ct">
      <img :src="`/api/fs/product/${app.thumb}`" />
      <p class="product-desc">{{ app.description }}</p>
    </div>
  </div>
</template>
<script>
import HttpService from '@/services/http.service'

export default {
  props: {
    app: {},
    favorites: Array,
  },
  data: function() {
    return {
      all_favs: [],
    }
  },
  created: async function() {
    this.all_favs = [...this.favorites]
  },
  methods: {
    async markFav(app) {
      app.isFavorite = !app.isFavorite
      const res = await HttpService.post('/user-profile/update-favorites', {
        app_id: app.db_id,
        place: 'home_page',
      })
      this.all_favs = res
      this.$emit('filterFavorites', this.all_favs)
    },
  },
}
</script>
<style scoped>
.fav-icon {
  visibility: hidden;
  color: rgba(214, 127, 60, 1);
}
.product-ct:hover .fav-icon:not(.selected-fav) {
  color: rgb(179 179 179);
}
.product-ct:hover .fav-icon,
.fav-icon.selected-fav {
  visibility: visible;
}
.product-ct {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-direction: column;
  padding: 12px;
}
.product-desc {
  flex: 1;
  font-size: 14px;
  line-height: 18px;
}
.product-ct div.ct {
  border-top: 1px solid #eaeaea;
  padding-top: 8px;
  margin-top: 4px;
  width: 100%;
}
.app-title {
  display: flex;
  align-items: center;
  width: 100%;
}
.app-title span {
  flex: 1;
}
img {
  width: 140px;
  height: 70px;
  float: right;
  margin-left: 10px;
  box-shadow: 0 1px 5px rgba(57, 63, 72, 0.1);
}
h3 {
  font-size: 100%;
  font-weight: bold;
  margin: 0;
  margin-bottom: 2px;
}
.badge {
  background: #0a4bb7;
  color: #fff;
  padding: 3px 8px;
  font-size: 12px;
  font-weight: normal;
  margin: 0 4px;
  border-radius: 4px;
}
.badge.updated {
  background: #282f54;
}
</style>
